import React from 'react';

import { normalizeTrunkSegment, tenantOptionValue } from '../../../../services/trunkName';

const LOCKED_TITLE = 'A operadora e o nome do tronco não podem ser alterados na edição.';

const CARRIER_STATUS_MESSAGES = {
  error: 'Não foi possível carregar as operadoras.',
  empty: 'Nenhuma operadora cadastrada. Cadastre em Configurações → Operadoras.',
};

const DEFAULT_IDENTITY = { status: 'ready', carriers: [], trunkName: '' };

const carrierOptionLabel = (carrier) => (normalizeTrunkSegment(carrier.name) ? carrier.name : `${carrier.name} (nome inválido)`);

function CarrierSelect({ identity, values, changeValues }) {
  if (identity.locked) {
    return (
      <select className="form-select" name="carrier" value={identity.lockedCarrierLabel} disabled title={LOCKED_TITLE}>
        <option value={identity.lockedCarrierLabel}>{identity.lockedCarrierLabel}</option>
      </select>
    );
  }

  if (identity.status !== 'ready') {
    return (
      <select className="form-select" name="carrier" value="" disabled>
        <option value="">{identity.status === 'loading' ? 'Carregando...' : 'Selecione'}</option>
      </select>
    );
  }

  return (
    <select className="form-select" name="carrier" value={values.carrierId || ''} onChange={(event) => changeValues({ name: 'carrierId', value: event.target.value })}>
      <option value="">Selecione</option>
      {identity.carriers.map((carrier) => (
        <option key={carrier.carrierId} value={String(carrier.carrierId)} disabled={!normalizeTrunkSegment(carrier.name)}>
          {carrierOptionLabel(carrier)}
        </option>
      ))}
    </select>
  );
}

function TrunkIdentityFields({ identity = DEFAULT_IDENTITY, tenants, values, changeValues }) {
  const carrierMessage = identity.locked ? '' : CARRIER_STATUS_MESSAGES[identity.status];

  return (
    <>
      <div className="form-field">
        <label className="form-label">Operadora</label>
        <CarrierSelect identity={identity} values={values} changeValues={changeValues} />
        {carrierMessage && <p className="form-error">{carrierMessage}</p>}
      </div>
      <div className="form-field">
        <label className="form-label">Cliente</label>
        <select className="form-select" name="tenant" value={values.tenant || ''} onChange={(event) => changeValues(event.target)}>
          <option value="">Selecione</option>
          {tenants.map((tenant, index) => (
            <option key={tenantOptionValue(tenant, index)} value={tenantOptionValue(tenant, index)}>{tenant.name}</option>
          ))}
        </select>
      </div>
      <div className="form-field trunk-grid-span-2">
        <label className="form-label">Nome do tronco</label>
        <input
          className="form-input"
          name="provider"
          type="text"
          value={identity.trunkName || ''}
          placeholder="Selecione operadora e cliente"
          title={identity.locked ? LOCKED_TITLE : ''}
          readOnly
        />
        {identity.batchBase && <p className="form-help">{`Os troncos serão criados como ${identity.batchBase}_<número>.`}</p>}
        {identity.nameError && <p className="form-error">{identity.nameError}</p>}
        <p name="provider-invalid-data" className="form-error is-hidden">Caracteres inválidos!</p>
      </div>
    </>
  );
}

export default TrunkIdentityFields;
